import { object, SchemaOf, string } from "yup";
import { requiredFieldValidationMessage } from "../../Forms/ValidationMessages";
import { Contact } from "../Contact";

export const contactSchema: SchemaOf<Contact> = object()
  .shape({
    LastName: string().required(requiredFieldValidationMessage("LastName")).default(""),
    Email: string().required(requiredFieldValidationMessage("Email")).default(""),
    Location: object().shape({
      Gsdb: string().required(requiredFieldValidationMessage("Gsdb")).default(""),
    }),
  })
  .required();
